import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import loadConfig from "../../../Services/Api/ApiServices";
import TableAHSF from "../../../Components/TableAHSF";
import { DeleteProjectModificationRequests } from "../../../Redux/Reducers/ReportStage/ProjectModificationRequests";
import ProjectModificationRequestsForm from "./ProjectModificationRequestsForm";

const ProjectModificationRequestsTable = (props) => {
  const Add = useSelector(
    (state) => state.ProjectModificationRequests.AddProjectModificationRequests
  );

  const [jsonData, setJsonData] = useState({});
  let location = window.location.pathname.split("/").includes("report");
  const [projectModificationRequestsId, setprojectModificationRequestsId] =
    useState(null);

  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "formattedCreateTime",
      ShowStatus: true,
      NmaeColumn: "تاريخ فتح الطلب",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "requestClosingDate",
      ShowStatus: true,
      NmaeColumn: "تاريخ اغلاق الطلب",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "requestType",
      ShowStatus: true,
      NmaeColumn: "نوع الطلب",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusNameEmployee",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "requestAttachment",
      ShowStatus: true,
      NmaeColumn: "مرفق طلب التعديل",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        if (objects.requestTypeId == "4f6c35eb-aad3-4fe9-a0ed-675e79db73a9") {
          if (location) {
            navigate(
              `/SRFund/report/TransferRequestDetails/${objects.reportId}/${objects.projectModificationRequestsId}`
            );
          } else {
            navigate(
              `/SRFund/TransferRequestDetails/${objects.reportId}/${objects.projectModificationRequestsId}`
            );
          }
        } else if (
          objects.requestTypeId == "02266f01-7eef-4998-8c91-d85814ec9981"
        ) {
          if (location) {
            navigate(
              `/SRFund/report/ProjectExtensionRequestDetails/${objects.reportId}/${objects.projectModificationRequestsId}`
            );
          } else {
            navigate(
              `/SRFund/ProjectExtensionRequestDetails/${objects.reportId}/${objects.projectModificationRequestsId}`
            );
          }
        }

        console.log(objects, "objects");
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      InitialScreeningAssessment: true,
    },
    // {
    //   Click: async (e) => {
    //     var objects = JSON.parse(e.target.value);
    //     var projectModificationRequestsId =
    //       objects.projectModificationRequestsId;

    //     Swal.fire({
    //       title: state.jsonData.deleteTitlePopUp?.nameAR,
    //       icon: "error",
    //       // iconHtml: "؟",
    //       confirmButtonText: "تأكيد",
    //       cancelButtonText: "الغاء",
    //       showCancelButton: true,
    //       showCloseButton: true,
    //     }).then(async (res) => {
    //       if (res.isConfirmed == true) {
    //         const deleted = await dispatch(
    //           DeleteProjectModificationRequests({
    //             projectModificationRequestsId: projectModificationRequestsId,
    //           })
    //         );
    //         if (deleted.payload) {
    //           Swal.fire({
    //             position: "center",
    //             icon: "success",
    //             title: "تم الحذف بنجاح",
    //             showConfirmButton: false,
    //             timer: 1500,
    //             // width: "500px",
    //           });
    //           //to refresh table
    //           dispatch(setRefreshTable());
    //         }
    //       }
    //     });
    //   },
    //   content: "",
    //   className: "bi bi-trash",
    //   id: "deleteBtn",
    //   title: "عرض",
    //   ShowStatus: location == false,

    //   // ShowStatus: true,
    //   //   !shouldDisableFields,
    // },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <ProjectModificationRequestsForm
        location={location}
        reportId={props.reportId}
      />
    ),

    title: "طلبات التعديل على المشروع",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  //   const popUpBody = {
  //     isPopupOpenStatus: popUpBodyStatus,
  //     isPopupOpenFunction: () => {
  //       setPopUpBodyStatus(false);
  //     },

  //     componentBody: (
  //       <ActivitesForm
  //         Action="edit"
  //         activitiesObjectivesId={returnCommentsId}
  //         reportId={props.reportId}
  //       />
  //     ),

  //     title: "الانشطة",
  //     maxWidth: "500px",
  //     maxHeight: "500px",
  //     idssss: "SecondarySectors",
  //   };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [Add]);

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        // RequestsManagerValue={true}
        AllValueAction={true}
        uniqueValue={"projectModificationRequestsId"}
        valueButtonAction={"projectModificationRequestsId"}
        URL={`api/ProjectModificationRequests/GetListProjectModificationRequests`}
        UrlBody={{
          reportId: props.reportId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"طلبات التعديل على المشروع"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={location == false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        uniqeKeyNameRedux={"tasksList"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody={
        //   <PopupAHSF
        //     idssss="SecondarySectors"
        //     isPopupOpenStatus={popUpBody.isPopupOpenStatus}
        //     isPopupOpenFunction={popUpBody.isPopupOpenFunction}
        //     title={popUpBody.title}
        //     componentBody={popUpBody.componentBody}
        //     maxWidth={popUpBody.maxWidth}
        //     maxHeight={popUpBody.maxHeight}
        //   />
        // }
      />
    </>
  );
};

export default ProjectModificationRequestsTable;
